/** @jsx h */
import { showCount } from '../config';
import Pagination from './Pagination';
import ResultTitle from './ResultTitle';

const TeaserChallenges = ({
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  function handleLoadMoreClick() {
    loadMore();
  }
  return (
    <div className="search-section__result-container">
      {allResultCount && showCount && (
        <div className="search-section__result-header">
          <ResultTitle allResultCount={allResultCount} />
        </div>
      )}

      <div className="hub-list hub-list--raw">
        <ol className="hub-list__list">
          {list.map(result => (
            <li className="hub-list__teaser" key={result.uid}>
              {result.image && (
                <div className="hub-list__teaser-image">
                  <picture>
                    <img
                      alt={result.image.alt ? result.image.alt : ''}
                      src={result.image.src}
                    />
                  </picture>
                </div>
              )}
              {result.mark && (
                <span className="hub-list__topic is-smaller">
                  {result.mark}
                </span>
              )}
              <div className="hub-list__teaser-headings">
                <span>{result.title}</span>
                {result.subtitle && (
                  <h3 className="is-link">
                    <a
                      href={result.url}
                      {...(result.isExternal
                        ? { target: '_blank', rel: 'noopener' }
                        : '')}
                    >
                      {result.subtitle}
                    </a>
                  </h3>
                )}
              </div>
            </li>
          ))}
        </ol>
      </div>

      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </div>
  );
};

export default TeaserChallenges;
